export const SHARED_CACHE_KEYS = {
  HTML: 'html'
} as const;
